import { createRequest } from "../tools";

/**
 * Fetches system fields from the API
 * @returns {Promise<{status: boolean, message: string, data: object}>}
 */
export const getSystemFields = async () => {
    return await createRequest({
        suffix: "system-fields",
        method: "get",
        handleError: true,
    });
};
